import ImageIconSolid from '@/components/icons/ImageIconSolid';
import { FC, Fragment } from 'react';
import { Skeleton } from '@/components/ui/skeleton';
import { Roles } from '@/@types/auth.types';

type Props = {
    footerButtons?: Roles;
};

const ApartmentsCardSkeleton: FC<Props> = ({ footerButtons }) => {
    const cardProperty = (
        <div className="h-5 flex items-center justify-between">
            <div className="flex items-center gap-2.5">
                <Skeleton className="size-3 rounded-full" />
                <Skeleton className="h-3 w-25 rounded-full" />
            </div>
            <Skeleton className="h-3 w-25 rounded-full" />
        </div>
    );

    return (
        <div className="flex flex-col flex-1 border border-popover-100 rounded-2.5xl bg-popover-10 overflow-hidden">
            <div className="h-50 flex items-center justify-center bg-popover-100">
                <ImageIconSolid className="size-16 fill-popover-400" />
            </div>
            <div className="p-6 flex flex-col gap-4 border-b border-popover-100">
                <div>
                    <div className="h-7 flex items-center">
                        <Skeleton className="h-3 w-16 rounded-full" />
                    </div>
                    <div className="h-6 flex items-center">
                        <Skeleton className="h-3 w-30 rounded-full" />
                    </div>
                </div>
                <div className="flex flex-col gap-4">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <Fragment key={index}>{cardProperty}</Fragment>
                    ))}
                </div>
            </div>
            {!!footerButtons && (
                <div className="p-6 flex justify-center gap-4">
                    <Skeleton className="h-11 flex-1 rounded-full" />
                    <Skeleton className="h-11 flex-1 rounded-full" />
                </div>
            )}
        </div>
    );
};

export default ApartmentsCardSkeleton;
